export default class SideNavTopLinkController {

}
